import dialogSize from '@/lib/calendesk-js-library/components/dialogs/dialogSize'

export default class Dialog {
  public open: boolean;
  public type: number;
  public size: number;
  public displayFooter: boolean;
  public title: string | null;
  public justifyTitle: string;
  public data: Record<string, any>;
  public ctaButtonTitle: string | null = null;
  public ctaButtonAction: string | null = null;
  public ctaButtonIcon: string | null = null;
  public ctaButtonColor: string | null = null;
  public secondaryButtonTitle: string | null = null;
  public secondaryButtonAction: string | null = null;
  public secondaryButtonIcon: string | null = null;

  constructor (open = false, type = 0, title: null | string = '', size = dialogSize.SMALL, displayFooter = false, justifyTitle = 'center', data: Record<string, any> = {}) {
    this.open = open
    this.type = type
    this.size = size
    this.displayFooter = displayFooter
    this.title = title
    this.justifyTitle = justifyTitle
    this.data = data
  }
}
